import { ICommandBarItemProps, IContextualMenuItem } from "@fluentui/react";
import { useBoolean } from '@fluentui/react-hooks';
import { RouterParams } from "App";
import { RootState } from "app/store";
import { EViewType } from "global/Application";
import { BuildVisibilityScope } from "global/Visibility/GlobalVisibility";
import { useEffect, useMemo, useState } from "react";
import { ConnectedProps, connect } from 'react-redux';
import { useParams } from "react-router-dom";
import GroupConfigurationSnapshotContext from "./GroupConfigurationSnapshotContext";
import FeesAndPremiumView from "./FeesAndPremium/FeesAndPremiumView";
import FeesAndPremiumProperties from "./FeesAndPremiumProperties";
import StopLossWizard from "./StopLossWizard";
import NonStandardApplyTemplate from "./NonStandardApplyTemplate";

interface IProps extends TComponentConnectedProps {
    // feesAndPremiums: FAM.IFeesAndPremiums;
}

const FeesAndPremium = (props: IProps) => {

    const disabled = props.state.status.viewType !== EViewType.Modify;

    const params = useParams<RouterParams>();

    const [propertiesIsOpen, setPropertiesIsOpen] = useState(false);

    const [stopLossWizardIsOpen, { setTrue: stopLossWizardOpen, setFalse: stopLossWizardClose }] = useBoolean(false);

    const [applyTemplateIsMounted, setApplyTemplateIsMounted] = useState(false);
    const [applyTemplateIsOpen, _setApplyTemplateIsOpen] = useState(false);
    const setApplyTemplateIsOpen: React.Dispatch<React.SetStateAction<boolean>> = (value) => {
        if (!applyTemplateIsMounted)
            setApplyTemplateIsMounted(true);
        _setApplyTemplateIsOpen(value);
    }

    useEffect(() => {
        document.title = `Fees and Premium`;

        if (feesAndPremium?.name)
            document.title = `Fees and Premium | ${feesAndPremium?.name}`;
    }, []);


    const contextMenu = useMemo(() => {

        const items: ICommandBarItemProps[] = [];

        if (!disabled)
            items.push({
                key: 'feesAndPremiumsProperties',
                text: 'Properties',
                iconProps: { iconName: 'Settings' },
                onClick: () => setPropertiesIsOpen(true)
            });
        if (!disabled)
            items.push({
                key: 'groupConfiguration.nonStandardTemplate.add',
                name: 'Apply Non-Standard Template',
                iconProps: { iconName: 'Generate' },
                onClick: (event, item) => {
                    setApplyTemplateIsOpen(true);
                },
            },);

        return { items: items, key: 'feesAndPremium' };
    }, [props.state.status.viewType]);

    const feesAndPremium = props.state?.data.json?.feesAndPremiums?.find(q => q.id === params.feesAndPremiumId);

    const menuStopLoss: IContextualMenuItem[] = [];

    if (!disabled)
        menuStopLoss.push(
            {
                key: `stopLossManage`,
                name: 'Manage',
                icon: 'DocumentManagement',
                onClick: (event, item) => {
                    if (event?.stopPropagation)
                        event.stopPropagation();

                    stopLossWizardOpen();
                },
                
            }
        );

    const controlVisibility = BuildVisibilityScope(
        null,
        props.state.data.json,
        null,
        null
    );

    const onRenderApplyTemplate = () => {
                if (!applyTemplateIsMounted)
                    return <></>
        
                return <>
                    <NonStandardApplyTemplate
                        isOpen={applyTemplateIsOpen}
                        onDismiss={() => { setApplyTemplateIsOpen(false); setApplyTemplateIsMounted(false) }}
                        feesAndPremium={feesAndPremium}
                        isNewNSAndChooseTemplate={false}
                    />
                </>;
            }

    return (
        <GroupConfigurationSnapshotContext contextMenu={contextMenu}>
            {feesAndPremium && <>
                {onRenderApplyTemplate()}
                <StopLossWizard
                    isOpen={stopLossWizardIsOpen}
                    onDismiss={stopLossWizardClose}
                    onCancel={stopLossWizardClose}
                    feesAndPremiums={feesAndPremium}
                    variant={'add-pick'}
                    onConfirm={(event) => {

                        stopLossWizardClose();
                    }}
                />

                <FeesAndPremiumProperties
                    isOpen={propertiesIsOpen}
                    onDismiss={() => setPropertiesIsOpen(false)}
                    data={{ feeAndPremium: feesAndPremium }}
                />

                <FeesAndPremiumView
                    disabled={disabled}
                    feesAndPremium={feesAndPremium}
                    visibility={controlVisibility}
                />

            </>}

        </GroupConfigurationSnapshotContext>
    )
}


function mapStateToProps(state: RootState) { return { state } }
const connector = connect(mapStateToProps);
type TComponentConnectedProps = ConnectedProps<typeof connector>;
export default connector(FeesAndPremium)